export default "__VITE_ASSET__1c78602b__"